"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const hoist_non_react_statics_1 = __importDefault(require("hoist-non-react-statics"));
const react_1 = __importStar(require("react"));
const libs_hooks_dom_1 = require("@hotelplan/libs.hooks-dom");
const feature_toggle_context_1 = require("./feature-toggle.context");
const feature_toggle_utils_1 = require("./feature-toggle.utils");
let eventSourceData = {};
function appWithFeatureToggle({ featureUpdatesEndpoint, onGetConfig, }) {
    return function (WrappedAppComponent) {
        function AppWithFeatureToggle(props) {
            const { config: initialConfig, userId } = (0, feature_toggle_utils_1.getFeatureTogglePageProp)(props.pageProps);
            const [featureToggleConfig, setFeatureToggleConfig] = (0, react_1.useState)(initialConfig);
            (0, react_1.useEffect)(() => {
                if (!('EventSource' in global))
                    return;
                onGetConfig === null || onGetConfig === void 0 ? void 0 : onGetConfig(initialConfig);
                function runEventSource() {
                    if (!eventSourceData || eventSourceData.userId !== userId) {
                        eventSourceData = {
                            userId,
                            source: new EventSource(featureUpdatesEndpoint),
                        };
                    }
                    if (eventSourceData.source) {
                        eventSourceData.source.onmessage = (e) => __awaiter(this, void 0, void 0, function* () {
                            const data = JSON.parse(e.data);
                            // NOTE: Receive the feature toggle config from the message.
                            const config = data === null || data === void 0 ? void 0 : data.config;
                            if (config) {
                                onGetConfig === null || onGetConfig === void 0 ? void 0 : onGetConfig(config);
                                setFeatureToggleConfig(config);
                            }
                        });
                    }
                }
                const idleId = (0, libs_hooks_dom_1.requestIdle)(runEventSource);
                return function cleanupEventSource() {
                    var _a;
                    (0, libs_hooks_dom_1.cancelIdle)(idleId);
                    (_a = eventSourceData.source) === null || _a === void 0 ? void 0 : _a.close();
                };
                // eslint-disable-next-line react-hooks/exhaustive-deps
            }, [userId]);
            const getFeature = (feature) => {
                if (process.env.NODE_ENV !== 'production') {
                    if (!(feature in featureToggleConfig)) {
                        // eslint-disable-next-line no-console
                        console.warn(`Feature toggle is trying to get '${feature}' non-setup feature`);
                    }
                }
                return ((featureToggleConfig === null || featureToggleConfig === void 0 ? void 0 : featureToggleConfig[feature]) || {
                    enabled: false,
                    variant: null,
                });
            };
            const isEnabled = (feature) => {
                return getFeature(feature).enabled;
            };
            const getVariant = (feature) => {
                return getFeature(feature).variant;
            };
            const ctxValue = {
                featureToggleConfig,
                isEnabled,
                getVariant,
            };
            return (react_1.default.createElement(feature_toggle_context_1.FeatureToggleContext.Provider, { value: ctxValue },
                react_1.default.createElement(WrappedAppComponent, Object.assign({}, props))));
        }
        return (0, hoist_non_react_statics_1.default)(AppWithFeatureToggle, WrappedAppComponent);
    };
}
exports.default = appWithFeatureToggle;
//# sourceMappingURL=appWithFeatureToggle.js.map